import { Globe2, Languages } from "lucide-react";
import { localeLabels, type Locale, useLocale } from "@/contexts/LocaleContext";

export default function LanguageSelector({ compact = false }: { compact?: boolean }) {
  const { locale, setLocale, t } = useLocale();

  if (compact) {
    return (
      <label
        className="immozwerg-language-selector immozwerg-language-selector--header relative inline-flex min-h-10 items-center gap-1 rounded-full px-3 text-sm font-bold shadow-sm"
        title={t("language")}
      >
        <Globe2 size={17} aria-hidden="true" />
        <span aria-hidden="true">{locale.toUpperCase()}</span>
        <select
          value={locale}
          onChange={(event) => setLocale(event.target.value as Locale)}
          aria-label={t("language")}
          className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
        >
          {Object.entries(localeLabels).map(([value, label]) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>
      </label>
    );
  }

  return (
    <label className="immozwerg-language-selector inline-flex min-h-11 items-center gap-2 rounded-full px-3 text-sm font-bold shadow-lg">
      <Languages size={18} aria-hidden="true" />
      <span className="sr-only">{t("language")}</span>
      <select
        value={locale}
        onChange={(event) => setLocale(event.target.value as Locale)}
        aria-label={t("language")}
        className="bg-transparent font-bold outline-none"
      >
        {Object.entries(localeLabels).map(([value, label]) => (
          <option key={value} value={value}>{label}</option>
        ))}
      </select>
    </label>
  );
}
